/**
 * @generated SignedSource<<21f21d6f385571191848a216895b5045>>
 * @relayHash 603a99eb4de760eebcce53e70a42aeb9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 603a99eb4de760eebcce53e70a42aeb9

import type { ConcreteRequest } from 'relay-runtime';
export type PinIssueCommentInput = {
  clientMutationId?: string | null | undefined;
  issueCommentId: string;
};
export type pinCommentMutation$variables = {
  input: PinIssueCommentInput;
};
export type pinCommentMutation$data = {
  readonly pinIssueComment: {
    readonly clientMutationId: string | null | undefined;
    readonly issueComment: {
      readonly id: string;
      readonly isPinned: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type pinCommentMutation$rawResponse = {
  readonly pinIssueComment: {
    readonly clientMutationId: string | null | undefined;
    readonly issueComment: {
      readonly id: string;
      readonly isPinned: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type pinCommentMutation = {
  rawResponse: pinCommentMutation$rawResponse;
  response: pinCommentMutation$data;
  variables: pinCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PinIssueCommentPayload",
    "kind": "LinkedField",
    "name": "pinIssueComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IssueComment",
        "kind": "LinkedField",
        "name": "issueComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPinned",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pinCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pinCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "603a99eb4de760eebcce53e70a42aeb9",
    "metadata": {},
    "name": "pinCommentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "673a6daa0f5af1be2c52b8dd35e34de1";

export default node;
